/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromptLibrarySubcategory } from './PromptLibrarySubcategory';
import {
    PromptLibrarySubcategoryFromJSON,
    PromptLibrarySubcategoryFromJSONTyped,
    PromptLibrarySubcategoryToJSON,
    PromptLibrarySubcategoryToJSONTyped,
} from './PromptLibrarySubcategory';

/**
 * 
 * @export
 * @interface PromptLibraryCategory
 */
export interface PromptLibraryCategory {
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryCategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryCategory
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryCategory
     */
    icon: string;
    /**
     * 
     * @type {Array<PromptLibrarySubcategory>}
     * @memberof PromptLibraryCategory
     */
    subcategories: Array<PromptLibrarySubcategory>;
}

/**
 * Check if a given object implements the PromptLibraryCategory interface.
 */
export function instanceOfPromptLibraryCategory(value: object): value is PromptLibraryCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    if (!('subcategories' in value) || value['subcategories'] === undefined) return false;
    return true;
}

export function PromptLibraryCategoryFromJSON(json: any): PromptLibraryCategory {
    return PromptLibraryCategoryFromJSONTyped(json, false);
}

export function PromptLibraryCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptLibraryCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'icon': json['icon'],
        'subcategories': ((json['subcategories'] as Array<any>).map(PromptLibrarySubcategoryFromJSON)),
    };
}

export function PromptLibraryCategoryToJSON(json: any): PromptLibraryCategory {
    return PromptLibraryCategoryToJSONTyped(json, false);
}

export function PromptLibraryCategoryToJSONTyped(value?: PromptLibraryCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'icon': value['icon'],
        'subcategories': ((value['subcategories'] as Array<any>).map(PromptLibrarySubcategoryToJSON)),
    };
}

